const paths = {
  homePage: '/',
  loginPage: '/login',
  archivePage: '/archive',
  statementPage: '/statement/:id',
  statementViewPage: '/statementView/:id',
  journalPage: '/journal',
  attachChildPage: '/attachChild',
  comparePhotoPage: '/comparePhoto',
  receivedVoucherPage: '/receivedVoucherPage',
  comparePhotoResultPage: '/comparePhoto/result/:id',
  comparePhotoPassportPage:
    '/comparePhoto/result/:id/:firstContingentId/:secondContingentId',
  monitoringTablePage: '/monitoring/table',
  monitoringChartsPage: '/monitoring/charts',
  monitoringChildrenPage: '/monitoring/children',
  monitoringStaffPage: '/monitoring/staff',
  monitoringReportsVoucherHoldersPage:'/monitoring/reports/voucherHolders',
  monitoringServiceProviderPage: '/monitoring/serviceProviders',
  monitoringContingentPage: '/monitoring/contingent',
  handbookPage: '/handbook',
  serviceProvidersPage: '/serviceProviders',
  serviceProviderPage: '/serviceProviders/:mode/:id?',
  serviceProviderViewPage: '/serviceProviders/view/:id',
  administrationPage: '/administration',
  instructionPage: '/instruction',
  contactSupportPage: '/contactSupportPage',
  manualPage: '/manualPage',
  voucherWaitingListPage: '/voucherWaitingListPage',
  faqPage: '/faqPage',
  myTaskPage: '/myTask',
  taskPage: '/task/:id',
  queueTab1Page: '/queue/tab1',
  queueTab2Page: '/queue/tab2',
  queueByName: '/queue/queueByName',
  resetPassPage: '/resetpass/:id?',
  changePass: '/need-change-password',
  kezekBulletinTable: '/kezekBulletinTable',
  kezekBulletin: '/bulletin/:id?',
  kezekDirectionTable: '/kezekDirectionTable',
  kezekDirection: '/direction/:id',
  kezekContingent: '/kezekContingent',
  kezekPassport: '/kezekPassport',
  kezekRequest: '/kezekRequest',
  kezekStopList: '/kezekStopList',
  kezekArchive: '/kezekArchive',
  contingentCandidatePage: '/contingent/candidate',
  contingentEnrolledPage: '/contingent/enrolled',
  contingentExitedPage: '/contingent/exited',
  groupsTabelPage: '/groups',
  groupPage: '/groups/add/:id?',
  groupListPage: '/groups/:id?',
  classPage: '/class',
  classAddPage: '/class/add/:id?',
  classItemPage: '/class/:id?',
  contingentItemPage: '/contingent/item/:id?',
  contingentItemAddPage: '/contingent/item/add',
  employeesPage: '/colleague/employees',
  dismissedPage: '/colleagues/dismissed',
  colleaguesPassportPage: '/colleagues/save',
  colleaguesPassportUpdatePage: '/colleagues/save/:id?',
  contingentPupilsPage: '/contingent/pupils',
  contingentRetiredPage: '/contingent/retired',
  contingentSchoolPage: '/contingent/school',
  contingentSchoolItemPage: '/contingent/school/:id?',
  contingentStudentPage: '/contingent/student',
  contingentDepartPage: '/contingent/depart',
  contingentSectionPage: '/contingent/section',
  contingentSectionItemPage: '/contingent/section/:id?',
  colleaguesReportPage: '/colleagues/report',
  contingentReportSchoolPage: '/contingent/reportSchool',
  contingentReportSectionPage: '/contingent/reportSection',
  contingentReportDDOPage: '/contingent/reportDDO',
  contingentReportFoodPage: '/contingent/reportFood',
  vouchersPage: '/vouchers',
  talonRegistrationPage: '/talonRegistration',
  talonRegistrationViewPage: '/talonRegistration/:id'
};

export default paths;
